
// import axios from "axios";
// import apiClient from "../../utils/apiclient";

// export const getreportdata=async(reqBody:{
//    locations: string;
//       search: string;
//       page: string,
//       limit: number,
//       lastLogin:string,
//       TaskTypes: string[]; // Change from string to string[]
//       TaskStatus: string[]; // Change from string to string[]
//       taskIds: string[];
//       Reassign_count:number[]
     
//   },token:string)=>{
//      return await apiClient.post('/reports/getting_reportdata_v1',reqBody,{
//         headers:{
//            Authorization: `Bearer ${token}`
//         }
//      })
//   }
  
  
//   export const getreportdetails = async (
//    reqBody: {
//      retailer_id: string;
//      task_type: string[]; // Change from string to string[]
//      task_status: string[]; // Change from string to string[]
//      task_name: string; // Change from string to string[]
//      task_start_date: string | null;
//      task_end_date: string | null;
//    },
//    token: string
//  ) => {
//    return await apiClient.post('/reports/getting_task_detailsdata_V1', reqBody, {
//      headers: {
//        Authorization: `Bearer ${token}`,
//      },
//    });
//  };
 
// // export const getreportdetails = async (
// //    reqBody: {
// //      retailer_id: string;
// //      task_type: string[];
// //      task_status: string[];
// //      task_name: string[]; // task_name should be an array of strings
// //      task_start_date: string | null;
// //      task_end_date: string | null;
// //    },
// //    token: string
// //  ) => {
// //    return await apiClient.post('/reports/getting_task_detailsdata', reqBody, {
// //      headers: {
// //        Authorization: `Bearer ${token}`,
// //      },
// //    });
// //  };
 
 
// export const getalllocations=async()=>{
//    return await apiClient.get('/city/distinctcity',{
    
//    })
// }

// export const getalltasktype=async()=>{
//    return await apiClient.get('/reports/getting_tasktype_dropdown',{
    
//    })
// }



// export const getalltaskstatus=async()=>{
//    return await apiClient.get('/reports/getting_taskstatus_dropdown',{
    
//    })
// }




//  export const getalltaskids = async () => {
//    return await apiClient.get(`/reports/getting_taskids`, {

//    });
//  };



// export const getallcsvdata = async (query: string) => {
//    return await apiClient.get(query, {
//      responseType: "arraybuffer",
//    });
//  };
 
    

 
     
//  export const getfilterdata = async (token: string, location: string | null,task_type:string, task_id:string,task_status:string,task_start_date:string,task_end_date:string) => {
//    return apiClient.get(`/reports/get-filter-data_V1`, {
//        headers: { Authorization: `Bearer ${token}` },
//        params: { location: location, task_type:task_type,task_id:task_id,task_status:task_status,task_start_date:task_start_date,task_end_date}
//    });
// };


//  export const getredemptionrequest=async()=>{
//    return await apiClient.get('/reports/get-redemption-request',{
    
//    })
//  }
 
 
 
//  export const getfilterdatabrands=async(token:string)=>{
//   return await apiClient.get('/reports/getFilterDatav1_brands',{
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
   
//   })
// }

 
//  export const getpointstransactions=async()=>{
//    return await apiClient.get('/reports/get-points-transaction',{
    
//    })
//  }
 
// export const viewretailers=async(reqBody:{
//    locations: string[];
//    outlet_type:string[]
//       search: string;
//       page: string,
//       limit: string,
//       lastLogin:string
     
//   },token:string)=>{
//      return await apiClient.post('/admin/task/view_retailers_v1',reqBody,{
//         headers:{
//            Authorization: `Bearer ${token}`
//         }
//      })
//   }


//   export const rewardSubPoints = async (
//    accountId: string,
//    selectedredemptions:string,
//    reqBody: any,
//    token: string
//  ) => {
//    try {
//      const response = await apiClient.get<{
//        status: any;
//        data: any[];
//      }>("/reports/get-accounts-data_V1", {
//        params: {
//          account_id: accountId,
//          selectedredemptions:selectedredemptions,
//          ...reqBody,
//        },
//        headers: {
//          Authorization: `Bearer ${token}`,
//        },
//      });
 
//      console.log("API Response:", response.data);
 
//      return response.data;
//    } catch (error) {
//      console.error("Error fetching reward points:", error);
//      throw error;
//    }
//  };
 
 
//  export const rewardPoint = async (reqBody: any, token: string) => {
//    try {
//      const response = await apiClient.post<{
//        totalCount: number;
//        message(
//          arg0: string,
//          message: (arg0: string, message: any) => unknown
//        ): unknown;
//        message(arg0: string, message: any): unknown;
//        status: any;
//        data: any[];
//      }>("/reports/get-rewards-data", reqBody, {
//        headers: {
//          Authorization: `Bearer ${token}`,
//        },
//      });
 
//      console.log("API Response:", response.data); // Debugging Log
 
//      return response.data; // Ensure this returns only data
//    } catch (error) {
//      console.error("Error fetching reward points:", error);
//      throw error; // Ensure error is thrown properly
//    }
//  };

//  export const uploadcsv = async (file: File) => {
//   const formData = new FormData();
//   formData.append('document_path', file); 
  
//   return await apiClient.post('/import-csv/import-csv-data', formData, {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//   });
// };


//   export const priorityusers=async(reqBody:{
//    task_not_completed: string;
  
     
//   },token:string)=>{
//      return await apiClient.post('/dashboard/priority-users/v1',reqBody,{
//         headers:{
//            Authorization: `Bearer ${token}`
//         }
        
//      })
     
//   }


//   export const previewtaskapi=async(reqBody:{
//     task_id: string | undefined;
//     task_type:string | undefined
   
      
//    },token:string)=>{
//       return await apiClient.post('/barnd_banner/preview-task-details',reqBody,{
//          headers:{
//             Authorization: `Bearer ${token}`
//          }
         
//       })
      
//    }
import axios, { AxiosResponse } from "axios";
import apiClient from "../../utils/apiclient";

export const getreportdata=async(reqBody:{
   locations: string;
      search: string;
      page: string,
      limit: number,
      lastLogin:string,
      TaskTypes: string[]; // Change from string to string[]
      TaskStatus: string[]; // Change from string to string[]
      taskIds: string[];
      Reassign_count:number[]
     
  },token:string)=>{
     return await apiClient.post('/reports/getting_reportdata_v1',reqBody,{
        headers:{
           Authorization: `Bearer ${token}`
        }
     })
  }

  
export const gettaskdata=async(reqBody:{
   locations: string;
      search: string;
      page: string,
      limit: number,
      lastLogin:string,
      TaskTypes: string[]; // Change from string to string[]
      TaskStatus: string[]; // Change from string to string[]
      taskIds: string[];
      Reassign_count:number[]
     
  },token:string)=>{
     return await apiClient.post('/reports/get_taskdata',reqBody,{
        headers:{
           Authorization: `Bearer ${token}`
        }
     })
  }
  
  
  export const getreportdetails = async (
   reqBody: {
     retailer_id: string;
     task_type: string[]; // Change from string to string[]
     task_status: string[]; // Change from string to string[]
     task_name: string; // Change from string to string[]
     task_start_date: string | null;
     task_end_date: string | null;
   },
   token: string
 ) => {
   return await apiClient.post('/reports/getting_task_detailsdata_V1', reqBody, {
     headers: {
       Authorization: `Bearer ${token}`,
     },
   });
 };
 
// export const getreportdetails = async (
//    reqBody: {
//      retailer_id: string;
//      task_type: string[];
//      task_status: string[];
//      task_name: string[]; // task_name should be an array of strings
//      task_start_date: string | null;
//      task_end_date: string | null;
//    },
//    token: string
//  ) => {
//    return await apiClient.post('/reports/getting_task_detailsdata', reqBody, {
//      headers: {
//        Authorization: `Bearer ${token}`,
//      },
//    });
//  };
 
 
export const getalllocations=async()=>{
   return await apiClient.get('/city/distinctcity',{
    
   })
}

export const getalltasktype=async()=>{
   return await apiClient.get('/reports/getting_tasktype_dropdown',{
    
   })
}



export const getalltaskstatus=async()=>{
   return await apiClient.get('/reports/getting_taskstatus_dropdown',{
    
   })
}




 export const getalltaskids = async () => {
   return await apiClient.get(`/reports/getting_taskids`, {

   });
 };



export const getallcsvdata = async (query: string) => {
   return await apiClient.get(query, {
     responseType: "arraybuffer",
   });
 };
 
    

 
     
 export const getfilterdata = async (token: string, location: string | null,task_type:string, task_id:string,task_status:string,task_start_date:string,task_end_date:string) => {
   return apiClient.get(`/reports/get-filter-data_V1`, {
       headers: { Authorization: `Bearer ${token}` },
       params: { location: location, task_type:task_type,task_id:task_id,task_status:task_status,task_start_date:task_start_date,task_end_date}
   });
};

 export const gettasksfilter = async (token: string, location: string | null,task_type:string, task_id:string,task_status:string,task_start_date:string,task_end_date:string) => {
   return apiClient.get(`/reports/gettasksfilter`, {
       headers: { Authorization: `Bearer ${token}` },
       params: { location: location, task_type:task_type,task_id:task_id,task_status:task_status,task_start_date:task_start_date,task_end_date}
   });
};

 export const getredemptionrequest=async()=>{
   return await apiClient.get('/reports/get-redemption-request',{
    
   })
 }
 
 
 
 export const getfilterdatabrands=async(token:string)=>{
  return await apiClient.get('/reports/getFilterDatav1_brands',{
    headers: {
      Authorization: `Bearer ${token}`,
    },
   
  })
}

 
 export const getpointstransactions=async()=>{
   return await apiClient.get('/reports/get-points-transaction',{
    
   })
 }
 
export const viewretailers=async(reqBody:{
   locations: string[];
   outlet_type:string[]
      search: string;
      page: string,
      limit: string,
      lastLogin:string
     
  },token:string)=>{
     return await apiClient.post('/admin/task/view_retailers_v1',reqBody,{
        headers:{
           Authorization: `Bearer ${token}`
        }
     })
  }


  export const rewardSubPoints = async (
   accountId: string,
   selectedredemptions:string,
   reqBody: any,
   token: string
 ) => {
   try {
     const response = await apiClient.get<{
       status: any;
       data: any[];
     }>("/reports/get-accounts-data_V1", {
       params: {
         account_id: accountId,
         selectedredemptions:selectedredemptions,
         ...reqBody,
       },
       headers: {
         Authorization: `Bearer ${token}`,
       },
     });
 
     console.log("API Response:", response.data);
 
     return response.data;
   } catch (error) {
     console.error("Error fetching reward points:", error);
     throw error;
   }
 };
 
 
 // keep axios client import

/**
 * rewardPoint: existing endpoint wrapper.
 * Returns the server's response.data object (which contains data, count, filterOptions, etc).
 */
// rewardPoint: add optional signal param and forward to axios
export const rewardPoint = async (reqBody: any, token: string, signal?: AbortSignal) => {
  try {
    const response: AxiosResponse<any> = await apiClient.post(
      "/reports/get-rewards-data",
      reqBody,
      {
        headers: { Authorization: `Bearer ${token}` },
        // axios supports AbortSignal via `signal` in recent versions
        signal,
      }
    );

    console.log("rewardPoint - API Response shape:", Object.keys(response.data || {}));
    return response.data;
  } catch (error: any) {
    // If abort, make it clear in logs (not an actual error to show user)
    if (error?.name === "CanceledError" || error?.message === "canceled") {
      console.warn("rewardPoint request cancelled.");
      // throw or return depending on how you want to handle cancellation. We'll rethrow to keep behavior consistent.
      throw error;
    }
    console.error("Error fetching reward points:", error);
    throw error;
  }
};


// api call used by Filter Popup
export const getRewardsFilterOptions = async (
  locations: string[] | null,
  token: string,
  signal?: AbortSignal,
  // ✅ add retailer-level filters + keep existing keys for backward-compat
  extraFilters?: {
    outletNames?: string[] | null;
    pmi_entity_code?: string[] | null;
    pmiEntityCodes?: string[] | null; // backward compat
    outletTypes?: string[] | null;

    // ⭐ NEW retailer filters
    region?: string[] | null;
    asm_name?: string[] | null;
    area_code?: string[] | null;
    tse_name?: string[] | null;
    territory_code?: string[] | null;
    outlet_salesforce_id?: string[] | null;
    sfa_id?: string[] | null;
  }
) => {
  try {
    const pmiEntityForRequest =
      (extraFilters?.pmi_entity_code && extraFilters.pmi_entity_code.length
        ? extraFilters.pmi_entity_code
        : extraFilters?.pmiEntityCodes && extraFilters.pmiEntityCodes.length
        ? extraFilters.pmiEntityCodes
        : null);

    const reqBody = {
      page: 1,
      limit: 1,
      filters: {
        location: locations && locations.length ? locations : null,
        ...(extraFilters?.outletTypes ? { outletTypes: extraFilters.outletTypes } : {}),
        ...(extraFilters?.outletNames ? { outletNames: extraFilters.outletNames } : {}),
        ...(pmiEntityForRequest ? { pmi_entity_code: pmiEntityForRequest } : {}),

        // ⭐ forward NEW retailer filters when present
        ...(extraFilters?.region ? { region: extraFilters.region } : {}),
        ...(extraFilters?.asm_name ? { asm_name: extraFilters.asm_name } : {}),
        ...(extraFilters?.area_code ? { area_code: extraFilters.area_code } : {}),
        ...(extraFilters?.tse_name ? { tse_name: extraFilters.tse_name } : {}),
        ...(extraFilters?.territory_code ? { territory_code: extraFilters.territory_code } : {}),
        ...(extraFilters?.outlet_salesforce_id ? { outlet_salesforce_id: extraFilters.outlet_salesforce_id } : {}),
        ...(extraFilters?.sfa_id ? { sfa_id: extraFilters.sfa_id } : {}),
      },
      search_key: null,
      start: null,
      end: null,
      sort: null,
    };

    const response: AxiosResponse<any> = await apiClient.post(
      "/reports/get-rewards-data",
      reqBody,
      { headers: { Authorization: `Bearer ${token}` }, signal }
    );

    const body = response.data || {};
    const fo = body.filterOptions || (body.data && body.data.filterOptions) || null;

    const outletNames: string[] = Array.isArray(fo?.outletNames)
      ? fo.outletNames
      : Array.isArray(fo?.outletPairs)
      ? fo.outletPairs.map((p: any) => String(p.label || ""))
      : [];

    const pmiEntityCodes: string[] = Array.isArray(fo?.pmiEntityCodes) ? fo.pmiEntityCodes : [];

    const outletPairs: { label: string; value: string }[] = Array.isArray(fo?.outletPairs)
      ? fo.outletPairs.map((p: any) => ({
          label: String(p.label || ""),
          value: String(p.value || ""),
        }))
      : [];

    const pmiEntityCodesByOutlet: Record<string, string[]> =
      fo?.pmiEntityCodesByOutlet && typeof fo.pmiEntityCodesByOutlet === "object"
        ? fo.pmiEntityCodesByOutlet
        : {};

    const outletsByPmiEntityCode: Record<string, string[]> =
      fo?.outletsByPmiEntityCode && typeof fo.outletsByPmiEntityCode === "object"
        ? fo.outletsByPmiEntityCode
        : {};

    // ✅ dynamic lists from BE
    const availableOutletTypes: string[] = Array.isArray(fo?.availableOutletTypes)
      ? fo.availableOutletTypes
      : [];

    const availableLocations: string[] = Array.isArray(fo?.availableLocations)
      ? fo.availableLocations
      : [];

    // ⭐ NEW: retailer-level dynamic lists
    const availableRegions: string[] = Array.isArray(fo?.availableRegions) ? fo.availableRegions : [];
    const availableAsmNames: string[] = Array.isArray(fo?.availableAsmNames) ? fo.availableAsmNames : [];
    const availableAreaCodes: string[] = Array.isArray(fo?.availableAreaCodes) ? fo.availableAreaCodes : [];
    const availableTseNames: string[] = Array.isArray(fo?.availableTseNames) ? fo.availableTseNames : [];
    const availableTerritoryCodes: string[] = Array.isArray(fo?.availableTerritoryCodes) ? fo.availableTerritoryCodes : [];
    const availableOutletSalesforceIds: string[] = Array.isArray(fo?.availableOutletSalesforceIds) ? fo.availableOutletSalesforceIds : [];
    const availableSfaIds: string[] = Array.isArray(fo?.availableSfaIds) ? fo.availableSfaIds : [];

    const sample = Array.isArray(body.data) && body.data.length > 0 ? body.data[0] : null;
    const hasMemberSinceField = !!(sample && Object.prototype.hasOwnProperty.call(sample, "member_since"));
    const hasLastLoginField = !!(sample && Object.prototype.hasOwnProperty.call(sample, "last_login"));

    return {
      outletNames,
      pmiEntityCodes,
      outletPairs,
      pmiEntityCodesByOutlet,
      outletsByPmiEntityCode,
      availableOutletTypes,   // existing
      availableLocations,     // existing

      // ⭐ expose new lists to the UI
      availableRegions,
      availableAsmNames,
      availableAreaCodes,
      availableTseNames,
      availableTerritoryCodes,
      availableOutletSalesforceIds,
      availableSfaIds,

      hasMemberSinceField,
      hasLastLoginField,
    };
  } catch (error) {
    console.error("Error fetching filterOptions:", error);
    return {
      outletNames: [],
      pmiEntityCodes: [],
      outletPairs: [],
      pmiEntityCodesByOutlet: {},
      outletsByPmiEntityCode: {},
      availableOutletTypes: [],
      availableLocations: [],

      // ⭐ ensure keys exist on error too
      availableRegions: [],
      availableAsmNames: [],
      availableAreaCodes: [],
      availableTseNames: [],
      availableTerritoryCodes: [],
      availableOutletSalesforceIds: [],
      availableSfaIds: [],

      hasMemberSinceField: false,
      hasLastLoginField: false,
    };
  }
};




export const getReportsFilterOptions_Ir = async (
  params: {
    locations?: string[] | null;
    pmi_entity_code?: string[] | null;
    outlet_name?: string[] | null;
    outlet_category?: string[] | null;
  },
  token: string,
  signal?: AbortSignal
) => {
  // 🔹 NEW: tiny normalizers
  const cleanStr = (s: any) => String(s ?? "").trim().replace(/\s+/g, " ");
  const uniqueCI = (arr: any[]) => {
    const seen = new Set<string>();
    const out: string[] = [];
    for (const v of arr || []) {
      const k = cleanStr(v).toLowerCase();
      if (!k || seen.has(k)) continue;
      seen.add(k);
      out.push(cleanStr(v));
    }
    return out;
  };

  try {
    const reqBody: any = {
      page: 1,
      limit: 1,
      ...(Array.isArray(params?.locations) && params.locations.length
        ? { locations: params.locations }
        : {}),
      ...(Array.isArray(params?.pmi_entity_code) && params.pmi_entity_code.length
        ? { pmi_entity_code: params.pmi_entity_code }
        : {}),
      ...(Array.isArray(params?.outlet_name) && params.outlet_name.length
        ? { outlet_name: params.outlet_name }
        : {}),
      ...(Array.isArray(params?.outlet_category) && params.outlet_category.length
        ? { outlet_category: params.outlet_category }
        : {}),
    };

    const response: AxiosResponse<any> = await apiClient.post(
      "/reports/getting_ir_data",
      reqBody,
      { headers: { Authorization: `Bearer ${token}` }, signal }
    );

    const body = response?.data ?? {};
    const host = body?.data && typeof body.data === "object" ? body.data : body;

    // 🔹 NEW: normalize everything we expose to the UI
    const availablePmi: string[] = uniqueCI(
      Array.isArray(host?.available_pmi_codes) ? host.available_pmi_codes : []
    );
    const availableOutletNames: string[] = uniqueCI(
      Array.isArray(host?.available_outlet_names) ? host.available_outlet_names : []
    );
    const availableCategories: string[] = uniqueCI(
      Array.isArray(host?.available_outlet_categories) ? host.available_outlet_categories : []
    );
    const availableCities: string[] = uniqueCI(
      Array.isArray(host?.available_cities) ? host.available_cities : []
    );

    const outletPairs: { label: string; value: string }[] =
      availableOutletNames.map((n) => ({ label: String(n), value: String(n) }));

    return {
      pmiEntityCodes: availablePmi,
      outletNames: availableOutletNames,
      outletPairs,
      outletCategories: availableCategories,
      cities: availableCities,
    };
  } catch (error) {
    console.error("Error fetching IR filter options:", error);
    return {
      pmiEntityCodes: [],
      outletNames: [],
      outletPairs: [],
      outletCategories: [],
      cities: [],
    };
  }
};





export const getReportsFilterOptions_IrTrans = async (
  params: {
    locations?: string[] | string | null;
    city?: string | string[] | null;
    pmi_entity_code?: string[] | string | null;
    outlet_name?: string[] | string | null;
    outlet_category?: string[] | string | null;
    transaction_from?: string | null;
    transaction_to?: string | null;
  },
  token: string,
  signal?: AbortSignal
) => {
  // helpers (ES5-safe)
  const toArray = (v: unknown): string[] =>
    Array.isArray(v) ? v : typeof v === "string" && v.trim() ? [v] : [];

  // ❗️ES5-friendly de-dupe (no Set / spread)
  const cleanList = (v: unknown): string[] => {
    const arr = toArray(v).map((s) => String(s).trim()).filter(Boolean);
    const seen: Record<string, 1> = {};
    const out: string[] = [];
    for (let i = 0; i < arr.length; i++) {
      const val = arr[i];
      if (!seen[val]) {
        seen[val] = 1;
        out.push(val);
      }
    }
    return out;
  };

  try {
    const reqBody: Record<string, any> = { page: 1, limit: 1 };

    const locs = cleanList(params?.locations ?? null);
    if (locs.length) reqBody.locations = locs;

    const cities = cleanList(params?.city ?? null);
    if (cities.length) reqBody.city = cities;

    const pmi = cleanList(params?.pmi_entity_code ?? null);
    if (pmi.length) reqBody.pmi_entity_code = pmi;

    const outletNames = cleanList(params?.outlet_name ?? null);
    if (outletNames.length) reqBody.outlet_name = outletNames;

    const categories = cleanList(params?.outlet_category ?? null);
    if (categories.length) reqBody.outlet_category = categories;

    if (params?.transaction_from && params.transaction_from.trim()) {
      reqBody.transaction_from = params.transaction_from.trim();
    }
    if (params?.transaction_to && params.transaction_to.trim()) {
      reqBody.transaction_to = params.transaction_to.trim();
    }

    const response: AxiosResponse<any> = await apiClient.post(
      "/reports/getting_ir_trans",
      reqBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        signal,
      }
    );

    const body = response?.data ?? {};
    const host = body?.data && typeof body.data === "object" ? body.data : body;

    const availablePmi: string[] = Array.isArray(host?.available_pmi_codes)
      ? host.available_pmi_codes
      : [];
    const availableOutletNames: string[] = Array.isArray(host?.available_outlet_names)
      ? host.available_outlet_names
      : [];
    const availableCategories: string[] = Array.isArray(host?.available_outlet_categories)
      ? host.available_outlet_categories
      : [];
    const availableCities: string[] = Array.isArray(host?.available_cities)
      ? host.available_cities
      : [];

    const outletPairs: { label: string; value: string }[] =
      availableOutletNames.map((n: string) => ({ label: String(n), value: String(n) }));

    return {
      pmiEntityCodes: availablePmi,
      outletNames: availableOutletNames,
      outletPairs,
      outletCategories: availableCategories,
      cities: availableCities,
    };
  } catch (error) {
    console.error("Error fetching IR-Transactions filter options:", error);
    return {
      pmiEntityCodes: [],
      outletNames: [],
      outletPairs: [],
      outletCategories: [],
      cities: [],
    };
  }
};



// frontend: src/pages/reports/api.ts  (or wherever you keep API helpers)
// adjust path to your configured axios instance

export const getReportsFilterOptions_Lo = async (
  params: {
    locations?: string[] | null;
    pmi_entity_code?: string[] | null; // ✅ allow narrowing by PMI
    outlet_name?: string[] | null;     // ✅ allow narrowing by Outlet
  },
  token: string,
  signal?: AbortSignal
) => {
  try {
    const reqBody: any = {
      page: 1,
      limit: 1,
      ...(Array.isArray(params?.locations) && params.locations.length
        ? { locations: params.locations }
        : {}),
      ...(Array.isArray(params?.pmi_entity_code) && params.pmi_entity_code.length
        ? { pmi_entity_code: params.pmi_entity_code }
        : {}),
      ...(Array.isArray(params?.outlet_name) && params.outlet_name.length
        ? { outlet_name: params.outlet_name }
        : {}),
    };

    // Hit Login & OTP endpoint that returns available_pmi_codes & available_outlet_names
    const response: AxiosResponse<any> = await apiClient.post(
      "/reports/get_lop_data",
      reqBody,
      { headers: { Authorization: `Bearer ${token}` }, signal }
    );

    // Controller typically returns:
    // { success, message, total_rows, page, limit, results, available_pmi_codes, available_outlet_names }
    // but support a nested data wrapper too.
    const body = response?.data ?? {};
    const host = body?.data && typeof body.data === "object" ? body.data : body;

    const availablePmi: string[] = Array.isArray(host?.available_pmi_codes)
      ? host.available_pmi_codes
      : [];
    const availableOutletNames: string[] = Array.isArray(host?.available_outlet_names)
      ? host.available_outlet_names
      : [];

    // Keep other legacy keys for UI compatibility (empty here)
    const asmNames: string[] = [];
    const areaCodes: string[] = [];
    const tseNames: string[] = [];
    const territoryCodes: string[] = [];
    const sfaIds: string[] = [];

    // For compatibility with prior consumers
    const outletPairs: { label: string; value: string }[] =
      availableOutletNames.map((n) => ({ label: String(n), value: String(n) }));

    // Locations are not returned by this endpoint
    const locationsFromFo: string[] = [];

    return {
      asmNames,
      areaCodes,
      tseNames,
      territoryCodes,
      sfaIds,
      pmiEntityCodes: availablePmi,     // ✅ exact backend key normalized
      outletNames: availableOutletNames, // ✅ exact backend key normalized
      outletPairs,
      locations: locationsFromFo,
    };
  } catch (error) {
    console.error("Error fetching login report filterOptions:", error);
    return {
      asmNames: [],
      areaCodes: [],
      tseNames: [],
      territoryCodes: [],
      sfaIds: [],
      pmiEntityCodes: [],
      outletNames: [],
      outletPairs: [],
      locations: [],
    };
  }
};


type FiltersArg =
  | null
  | string[]
  | {
      outlet_city?: string[] | null;
      pmi_entity_code?: string[] | null;
      outletNames?: string[] | null;
      status?: string[] | null;
      user_salesforce_id?: string[] | null;
    };

export const getReportsFilterOptions = async (
  filtersOrLocations: FiltersArg,
  token: string,
  signal?: AbortSignal
) => {
  try {
    // 🔹 Back-compat: if the caller passed an array (old usage), treat it as locations
    const filters =
      Array.isArray(filtersOrLocations) || filtersOrLocations === null
        ? { locations: filtersOrLocations && filtersOrLocations.length ? filtersOrLocations : null }
        : {
            // new shape (send as-is, but normalize common aliases the BE expects)
            locations:
              (filtersOrLocations as any).locations ??
              (filtersOrLocations as any).outlet_city ??
              null,
            pmi_entity_code:
              (filtersOrLocations as any).pmi_entity_code ?? null,
            outletNames:
              (filtersOrLocations as any).outletNames ?? null,
            status:
              (filtersOrLocations as any).status ?? null,
            user_salesforce_id:
              (filtersOrLocations as any).user_salesforce_id ?? null,
          };

    const reqBody = {
      page: 1,
      limit: 1,
      filters,
      search_key: null,
      start: null,
      end: null,
      sort: null,
    };

    const response: AxiosResponse<any> = await apiClient.post(
      "/reports/master_outlet_list_v1",
      reqBody,
      {
        headers: { Authorization: `Bearer ${token}` },
        signal,
      }
    );

    const body = response.data || {};
    const fo =
      body.filterOptions ||
      (body.data && body.data.filterOptions) ||
      null;

    // ---------- Normalize outputs ----------
    // locations
    const locations: string[] = Array.isArray(fo?.locations) ? fo.locations : [];

    // outlet names: prefer explicit list; otherwise map from outletPairs
    const outletNames: string[] = Array.isArray(fo?.outletNames)
      ? fo.outletNames
      : Array.isArray(fo?.outletPairs)
      ? fo.outletPairs.map((p: any) => String(p.label || "")).filter(Boolean)
      : [];

    // outletPairs (stable value=id)
    const outletPairs: { label: string; value: string }[] = Array.isArray(fo?.outletPairs)
      ? fo.outletPairs.map((p: any) => ({
          label: String(p.label || ""),
          value: String(p.value || ""),
        }))
      : [];

    // PMIs
    const pmiEntityCodes: string[] = Array.isArray(fo?.pmiEntityCodes) ? fo.pmiEntityCodes : [];

    // statuses (support several legacy keys)
    const statuses: string[] =
      Array.isArray(fo?.statuses)
        ? fo.statuses
        : Array.isArray(fo?.userStatuses)
        ? fo.userStatuses
        : Array.isArray(fo?.status)
        ? fo.status
        : [];

    // ✅ User Salesforce IDs (new facet; support a couple of keys just in case)
    const userSalesforceIds: string[] =
      Array.isArray((fo as any)?.userSalesforceIds)
        ? (fo as any).userSalesforceIds
        : Array.isArray((fo as any)?.user_sfa_ids)
        ? (fo as any).user_sfa_ids
        : Array.isArray((fo as any)?.sfaIds) // legacy generic name
        ? (fo as any).sfaIds
        : [];

    return {
      locations,
      outletNames,
      pmiEntityCodes,
      statuses,
      userSalesforceIds, // 👈 FE expects this key
      outletPairs,
    };
  } catch (error) {
    console.error("Error fetching report filterOptions:", error);
    return {
      locations: [],
      outletNames: [],
      pmiEntityCodes: [],
      statuses: [],
      userSalesforceIds: [],
      outletPairs: [],
    };
  }
};



export interface MasterFilterParams {
  region?: string[] | null;                       // <-- NEW
  city?: string[] | null;
  asm_name?: string[] | null;
  area_code?: string[] | null;
  tse_name?: string[] | null;
  territory_code?: string[] | null;
  sfa_id?: string[] | null;
  outlet_salesforce_id?: string[] | null;
  pmi_entity_code?: string[] | null;
  outlet_name?: string[] | null;
  status?: string[] | null;

  // FE uses these names; BE also expects these exact keys:
  contractedSince_from?: string | null;
  contractedSince_to?: string | null;
  lastUpdated_on_from?: string | null;
  lastUpdated_on_to?: string | null;
}

export interface MasterFilterResponse {
  // legacy keys your FE already uses
  available_pmi_codes: string[];
  available_outlet_names: string[];
  outletPairs: Array<{ outlet_name: string; pmi_entity_code: string; city: string }>;

  // new dynamic lists (aligns with exportRetailersAndAccounts_Master)
  available_regions: string[];                    // <-- NEW
  available_asm_names: string[];
  available_area_codes: string[];
  available_tse_names: string[];
  available_territory_codes: string[];
  available_sfa_ids: string[];
  available_outlet_salesforce_ids: string[];
  available_cities: string[];
  available_statuses: string[];
}

export const getReportsFilterOptions_v2 = async (
  params: MasterFilterParams,
  token: string,
  signal?: AbortSignal
): Promise<MasterFilterResponse> => {
  try {
    // Build strict BE request (we call the master endpoint with a tiny page to fetch distincts)
    const reqBody: Record<string, any> = {
      page: 1,
      limit: 1,

      ...(Array.isArray(params?.region) && params.region.length ? { region: params.region } : {}), // <-- NEW
      ...(Array.isArray(params?.city) && params.city.length ? { city: params.city } : {}),
      ...(Array.isArray(params?.asm_name) && params.asm_name.length ? { asm_name: params.asm_name } : {}),
      ...(Array.isArray(params?.area_code) && params.area_code.length ? { area_code: params.area_code } : {}),
      ...(Array.isArray(params?.tse_name) && params.tse_name.length ? { tse_name: params.tse_name } : {}),
      ...(Array.isArray(params?.territory_code) && params.territory_code.length ? { territory_code: params.territory_code } : {}),
      ...(Array.isArray(params?.sfa_id) && params.sfa_id.length ? { sfa_id: params.sfa_id } : {}),
      ...(Array.isArray(params?.outlet_salesforce_id) && params.outlet_salesforce_id.length
        ? { outlet_salesforce_id: params.outlet_salesforce_id }
        : {}),
      ...(Array.isArray(params?.pmi_entity_code) && params.pmi_entity_code.length
        ? { pmi_entity_code: params.pmi_entity_code }
        : {}),
      ...(Array.isArray(params?.outlet_name) && params.outlet_name.length
        ? { outlet_name: params.outlet_name }
        : {}),
      ...(Array.isArray(params?.status) && params.status.length ? { status: params.status } : {}),

      // Date filters (exact BE keys)
      ...(params?.contractedSince_from ? { contractedSince_from: params.contractedSince_from } : {}),
      ...(params?.contractedSince_to ? { contractedSince_to: params.contractedSince_to } : {}),
      ...(params?.lastUpdated_on_from ? { lastUpdated_on_from: params.lastUpdated_on_from } : {}),
      ...(params?.lastUpdated_on_to ? { lastUpdated_on_to: params.lastUpdated_on_to } : {}),
    };

    // NOTE: If your backend route differs, update this path:
    const response: AxiosResponse<any> = await apiClient.post(
      "/reports/get_lopas_data",
      reqBody,
      { headers: { Authorization: `Bearer ${token}` }, signal }
    );

    const body = response?.data ?? {};
    const host =
      body && typeof body === "object" && body.data && typeof body.data === "object"
        ? body.data
        : body;

    // Old keys (still consumed by FE)
    const available_pmi_codes: string[] = Array.isArray(host?.available_pmi_codes) ? host.available_pmi_codes : [];
    const available_outlet_names: string[] = Array.isArray(host?.available_outlet_names) ? host.available_outlet_names : [];

    // New dynamic lists from the master API
    const available_regions: string[] = Array.isArray(host?.available_regions) ? host.available_regions : []; // <-- NEW
    const available_asm_names: string[] = Array.isArray(host?.available_asm_names) ? host.available_asm_names : [];
    const available_area_codes: string[] = Array.isArray(host?.available_area_codes) ? host.available_area_codes : [];
    const available_tse_names: string[] = Array.isArray(host?.available_tse_names) ? host.available_tse_names : [];
    const available_territory_codes: string[] = Array.isArray(host?.available_territory_codes) ? host.available_territory_codes : [];
    const available_sfa_ids: string[] = Array.isArray(host?.available_sfa_ids) ? host.available_sfa_ids : [];
    const available_outlet_salesforce_ids: string[] = Array.isArray(host?.available_outlet_salesforce_ids)
      ? host.available_outlet_salesforce_ids
      : [];
    const available_cities: string[] = Array.isArray(host?.available_cities) ? host.available_cities : [];
    const available_statuses: string[] = Array.isArray(host?.available_statuses) ? host.available_statuses : [];

    // Derive outlet–PMI–city tuples from results (kept for backward-compat)
    const results: any[] = Array.isArray(host?.results) ? host.results : [];
    const outletPairs = Array.from(
      new Map(
        results
          .map((r) => ({
            outlet_name: typeof r?.outlet_name === "string" ? r.outlet_name.trim() : "",
            pmi_entity_code: typeof r?.pmi_entity_code === "string" ? r.pmi_entity_code.trim() : "",
            city: typeof r?.city === "string" ? r.city.trim() : "",
          }))
          .filter((x) => x.outlet_name && x.pmi_entity_code)
          .map((x) => [`${x.outlet_name}__${x.pmi_entity_code}__${x.city}`, x])
      ).values()
    );

    return {
      // legacy keys
      available_pmi_codes,
      available_outlet_names,
      outletPairs,

      // new dynamic lists
      available_regions,                          // <-- NEW
      available_asm_names,
      available_area_codes,
      available_tse_names,
      available_territory_codes,
      available_sfa_ids,
      available_outlet_salesforce_ids,
      available_cities,
      available_statuses,
    };
  } catch (error) {
    console.error("Error fetching Master filter options:", error);
    // Strict shape on failure
    return {
      available_pmi_codes: [],
      available_outlet_names: [],
      outletPairs: [],
      available_regions: [],                      // <-- NEW
      available_asm_names: [],
      available_area_codes: [],
      available_tse_names: [],
      available_territory_codes: [],
      available_sfa_ids: [],
      available_outlet_salesforce_ids: [],
      available_cities: [],
      available_statuses: [],
    };
  }
};



export interface TxFilterOptionsResponse {
  cities: string[];
  outlets: string[];
  outletPairs: Array<{ label: string; value: string }>;
  regions: string[];
  outletCategories: string[];
  transactionTypes: string[];
  redemptionStatuses: string[];

  // maps (canonical)
  cityToOutlets: Record<string, string[]>;
  outletToCities: Record<string, string[]>;
  cityToCategories: Record<string, string[]>;
  outletToCategories: Record<string, string[]>;
  categoryToOutlets: Record<string, string[]>;
  cityToTransactions: Record<string, string[]>;
  cityToStatuses: Record<string, string[]>;
  outletToTransactions: Record<string, string[]>;
  outletToStatuses: Record<string, string[]>;
  categoryToTransactions: Record<string, string[]>;
  categoryToStatuses: Record<string, string[]>;
  transactionToStatuses: Record<string, string[]>;
  statusToTransactions: Record<string, string[]>;
  regionToCities: Record<string, string[]>;
  regionToOutlets: Record<string, string[]>;
  regionToCategories: Record<string, string[]>;

  // legacy aliases the FE may read
  transactionTypesByOutlet: Record<string, string[]>;
  redemptionStatusByOutlet: Record<string, string[]>;

  // diagnostics
  hasMemberSinceField: boolean;
  hasMemberSinceTs: boolean;
}

type ExtraFilters = {
  outletNames?: string[] | null;
  pmiEntityCodes?: string[] | null;
  outletTypes?: string[] | null;
  transactionTypes?: string[] | null;
  redemptionStatuses?: string[] | null;
};

const asArr = (v: unknown): string[] => (Array.isArray(v) ? v.map(String) : []);
const asMap = (v: unknown): Record<string, string[]> =>
  v && typeof v === "object" && !Array.isArray(v)
    ? Object.fromEntries(
        Object.entries(v as Record<string, unknown[]>).map(([k, arr]) => [String(k), asArr(arr)])
      )
    : {};

export const getTransactionFilterOptions = async (
  locations: string[] | null,
  token: string,
  signal?: AbortSignal,
  extraFilters: ExtraFilters = {}
): Promise<TxFilterOptionsResponse> => {
  try {
    const reqBody = {
      page: 1,
      limit: 1, // only need filterOptions
      filters: {
        // BE accepts either
        location: locations && locations.length > 0 ? locations : null,
        city: locations && locations.length > 0 ? locations : null,

        ...(extraFilters.outletTypes?.length ? { outletTypes: extraFilters.outletTypes } : {}),
        ...(extraFilters.outletNames?.length ? { outlet_name: extraFilters.outletNames } : {}),
        ...(extraFilters.pmiEntityCodes?.length ? { pmi_entity_code: extraFilters.pmiEntityCodes } : {}),
        ...(extraFilters.transactionTypes?.length ? { transaction_type: extraFilters.transactionTypes } : {}),
        ...(extraFilters.redemptionStatuses?.length ? { redemption_status: extraFilters.redemptionStatuses } : {}),
      },
      search_key: null,
      start: null,
      end: null,
      sort: null,
    };

    const response: AxiosResponse<any> = await apiClient.post(
      "/reports/transaction-view-rewards",
      reqBody,
      { headers: { Authorization: `Bearer ${token}` }, signal }
    );

    const body = response.data || {};
    const fo =
      body.filterOptions ||
      (body.data && body.data.filterOptions) ||
      body.data?.filterOptions ||
      {};

    // flat lists (support aliases)
    const cities              = asArr(fo.cities?.length ? fo.cities : fo.locations);
    const outlets             = fo.outlets?.length ? asArr(fo.outlets)
                            : fo.outletNames?.length ? asArr(fo.outletNames)
                            : Array.isArray(fo.outletPairs) ? fo.outletPairs.map((p: any) => String(p.label || "")) : [];
    const outletPairs         = Array.isArray(fo.outletPairs) ? fo.outletPairs.map((p: any) => ({
                              label: String(p.label || ""), value: String(p.value || "")
                            })) : [];
    const regions             = asArr(fo.regions);
    const outletCategories    = asArr(fo.outletCategories);
    const transactionTypes    = asArr(fo.transactionTypes);
    const redemptionStatuses  = asArr(fo.redemptionStatuses);

    // maps (canonical)
    const cityToOutlets        = asMap(fo.cityToOutlets);
    const outletToCities       = asMap(fo.outletToCities);
    const cityToCategories     = asMap(fo.cityToCategories);
    const outletToCategories   = asMap(fo.outletToCategories);
    const categoryToOutlets    = asMap(fo.categoryToOutlets);
    const cityToTransactions   = asMap(fo.cityToTransactions);
    const cityToStatuses       = asMap(fo.cityToStatuses);
    const outletToTransactions = asMap(fo.outletToTransactions);
    const outletToStatuses     = asMap(fo.outletToStatuses);
    const categoryToTransactions = asMap(fo.categoryToTransactions);
    const categoryToStatuses     = asMap(fo.categoryToStatuses);
    const transactionToStatuses  = asMap(fo.transactionToStatuses);
    const statusToTransactions   = asMap(fo.statusToTransactions);
    const regionToCities       = asMap(fo.regionToCities);
    const regionToOutlets      = asMap(fo.regionToOutlets);
    const regionToCategories   = asMap(fo.regionToCategories);

    // legacy aliases (for existing FE code)
    const transactionTypesByOutlet = Object.keys(outletToTransactions).length ? outletToTransactions : asMap(fo.transactionTypesByOutlet);
    const redemptionStatusByOutlet = Object.keys(outletToStatuses).length     ? outletToStatuses     : asMap(fo.redemptionStatusByOutlet);

    const sample = Array.isArray(body.data) && body.data.length > 0 ? body.data[0] : null;
    const hasMemberSinceField = !!(sample && Object.prototype.hasOwnProperty.call(sample, "member_since"));
    const hasMemberSinceTs    = !!(sample && Object.prototype.hasOwnProperty.call(sample, "member_since_ts"));

    return {
      cities,
      outlets,
      outletPairs,
      regions,
      outletCategories,
      transactionTypes,
      redemptionStatuses,

      cityToOutlets,
      outletToCities,
      cityToCategories,
      outletToCategories,
      categoryToOutlets,
      cityToTransactions,
      cityToStatuses,
      outletToTransactions,
      outletToStatuses,
      categoryToTransactions,
      categoryToStatuses,
      transactionToStatuses,
      statusToTransactions,
      regionToCities,
      regionToOutlets,
      regionToCategories,

      transactionTypesByOutlet,
      redemptionStatusByOutlet,

      hasMemberSinceField,
      hasMemberSinceTs,
    };
  } catch (error) {
    console.error("Error fetching transaction filterOptions:", error);
    return {
      cities: [],
      outlets: [],
      outletPairs: [],
      regions: [],
      outletCategories: [],
      transactionTypes: [],
      redemptionStatuses: [],

      cityToOutlets: {},
      outletToCities: {},
      cityToCategories: {},
      outletToCategories: {},
      categoryToOutlets: {},
      cityToTransactions: {},
      cityToStatuses: {},
      outletToTransactions: {},
      outletToStatuses: {},
      categoryToTransactions: {},
      categoryToStatuses: {},
      transactionToStatuses: {},
      statusToTransactions: {},
      regionToCities: {},
      regionToOutlets: {},
      regionToCategories: {},

      transactionTypesByOutlet: {},
      redemptionStatusByOutlet: {},

      hasMemberSinceField: false,
      hasMemberSinceTs: false,
    };
  }
};





 // api.ts
 export interface BackendFilterOptions {
  outletsByCity?: Record<string, string[]>;
  transactionTypesByOutlet?: Record<string, string[]>;
  redemptionStatusByOutlet?: Record<string, string[]>;
}

export interface TransactionViewRewardsResponse {
  data: any[];
  totalCount: number;
  filterOptions?: BackendFilterOptions;
}


export const transactionViewRewards = async (reqBody: any, token: string): Promise<TransactionViewRewardsResponse> => {
  try {
    const response = await apiClient.post<any>("/reports/transaction-view-rewards", reqBody, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Debug log (remove in production)
    console.log("transactionViewRewards raw response:", response?.data);

    // Normalise response shape (handle both styles you might return)
    const body = response?.data || {};
    const data = Array.isArray(body.data) ? body.data : [];
    const totalCount = typeof body.totalCount === "number" ? body.totalCount : (typeof body.count === "number" ? body.count : 0);
    const filterOptions: BackendFilterOptions | undefined = body.filterOptions || body.filter_options || undefined;

    return { data, totalCount, filterOptions };
  } catch (error) {
    console.error("Error fetching reward points:", error);
    throw error;
  }
};

// exportRewardsData.ts
export const exportRewardsData = async (params: any, token: string) => {
  // Normalize columns
  const normalized: any = { ...params };
  if (normalized.selectedColumns && !normalized.columns) {
    normalized.columns = Array.isArray(normalized.selectedColumns)
      ? normalized.selectedColumns.filter(Boolean).join(",")
      : normalized.selectedColumns;
  }
  delete normalized.selectedColumns;

  // If a filters object is present, JSON-encode it as a single query param
  const queryObj: Record<string, string> = {};

  // Move filters into a JSON string param (if present)
  if (normalized.filters && typeof normalized.filters === "object") {
    queryObj.filters = JSON.stringify(normalized.filters);
    delete normalized.filters;
  }

  // Add the rest of the flat params
  Object.entries(normalized).forEach(([k, v]) => {
    if (v === null || v === undefined) return;
    if (Array.isArray(v)) {
      // arrays become comma-separated (consistent with your previous code)
      queryObj[k] = v.join(",");
    } else {
      queryObj[k] = String(v);
    }
  });

  const query = new URLSearchParams(queryObj).toString();

  const response = await apiClient.get(
    `/reports/export-surewards-data?${query}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    }
  );

  return response.data; // blob
};



export const exportTranData = async (params: any, token: string) => {
  // Build query string from params
  const query = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value != null) {
      // If array, join with comma
      if (Array.isArray(value)) query.append(key, value.join(","));
      else query.append(key, value);
    }
  });

  // ✅ NEW: handle selected columns (if passed separately as an array)
  if (params.selectedColumns && Array.isArray(params.selectedColumns)) {
    query.append("columns", params.selectedColumns.join(",")); 
  }

  const response = await apiClient.get(
    `/reports/export-trnrewards-data?${query.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    }
  );

  return response.data;
};





 
 export const uploadcsv = async (file: File) => {
  const formData = new FormData();
  formData.append('document_path', file); 
  
  return await apiClient.post('/import-csv/import-csv-data', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};


  export const priorityusers=async(reqBody:{
   task_not_completed: string;
  
     
  },token:string)=>{
     return await apiClient.post('/dashboard/priority-users/v1',reqBody,{
        headers:{
           Authorization: `Bearer ${token}`
        }
        
     })
     
  }


    export const passbokkdata=async(reqBody:{
   contactid: string;
  
     
  },token:string)=>{
     return await apiClient.post('/admin/task/get_all_pacebook_details',reqBody,{
        headers:{
           Authorization: `Bearer ${token}`
        }
        
     })
     
  }



  export const previewtaskapi=async(reqBody:{
    task_id: string | undefined;
    task_type:string | undefined
   
      
   },token:string)=>{
      return await apiClient.post('/barnd_banner/preview-task-details',reqBody,{
         headers:{
            Authorization: `Bearer ${token}`
         }
         
      })
      
   }



   export const export_retailers=async(reqBody:{
   locations: string[];
   outlet_type:string[]
      search: string;
     
      lastLogin:string
     
  },token:string)=>{
     return await apiClient.post('/admin/task/export_retailers_data',reqBody,{
        headers:{
           Authorization: `Bearer ${token}`
        }
     })
  }

  export const getExportRetailers = async (reqBody: {
  locations: string[];
  outlet_type: string[];
  search: string;
  lastLogin: string;
  startDate?: string;
    endDate?: string;

 },token:string)=>{
  return await apiClient.post('/admin/task/export_retailers_data', reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob', // important for Excel download
  });
};

export const exportActivityLogs = async (
  reqBody: {
    dateRange?: { from: string; to: string };
    search?: string;
    page?: number;
    limit?: number;
  },
  token: string
) => {
  return await apiClient.post('/import-csv/get-activity-logs-export', reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob', // ✅ important to receive Excel file
  });
};

  export const getExportRewards = async (reqBody: any, token: string) => {
  try {
    const response = await apiClient.post<Blob>(
      "/reports/export-rewards-data",
      reqBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // important for Excel download
      }
    );

    // Convert blob to downloadable file
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "rewards.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();

    return response.data;
  } catch (error) {
    console.error("Error fetching reward points:", error);
    throw error;
  }
};


// --- 1. Export retailers and accounts wrapper ---
export const exportRetailersAndAccounts = async (
  reqBody: {
    locations?: string[];
    outlet_category?: string[];
    device_type?: string[];
    pmi_entity_code?: string[];
    outlet_name?: string[];
    search?: string | string[];
    page?: number;
    limit?: number | string; // allow string "all"
    lastLogin?: { from: string; to: string };
    export?: boolean;        // optional export flag
  },
  loginToken: string,
  exportCSV?: boolean
): Promise<any> => {
  try {
    const endpoint = "/reports/get_lop_data";

    const response = await apiClient.post(endpoint, reqBody, {
      headers: {
        withCredentials: true,
        Authorization: `Bearer ${loginToken}`,
      },
      responseType: exportCSV ? "blob" : "json",
    });

    if (exportCSV && response.data) {
      return response.data;
    }

    return response.data;
  } catch (error) {
    console.error("Error exporting retailers and accounts:", error);
    throw error;
  }
};


export type SortDir = "asc" | "desc";

export const exportRetailersAndAccounts_v1 = async (
  reqBody: {
    region ?: string | string [];
    city?: string | string[];
    asm_name?: string | string[];
    area_code?: string | string[];
    tse_name?: string | string[];
    territory_code?: string | string[];
    sfa_id?: string | string[];
    outlet_salesforce_id?: string | string[];
    pmi_entity_code?: string | string[];
    outlet_name?: string | string[];
    status?: string | string[];
    contractedSince_from?: string;
    contractedSince_to?: string;
    lastUpdated_on_from?: string;
    lastUpdated_on_to?: string;
    search?: string;
    q?: string;
    keyword?: string;
    sort_dir?: SortDir;
    page?: number;
    limit?: number | string; // allow "all"
    export?: boolean;
  },
  loginToken: string,
  exportCSV?: boolean,
   signal?: AbortSignal 
): Promise<any> => {
  try {
    const endpoint = "/reports/get_lopas_data";

    const response = await apiClient.post(endpoint, reqBody, {
      headers: {
        withCredentials: true,
        Authorization: `Bearer ${loginToken}`,
      },
      responseType: exportCSV ? "blob" : "json",
       signal, 
    });

    if (exportCSV && response.data) {
      return response.data; // return CSV blob
    }

    return response.data; // BE returns { results, total_rows, available_pmi_codes, ... }
  } catch (error) {
    console.error("Error exporting retailers & accounts:", error);
    throw error;
  }
};


export const exportRetailersAndAccounts_csv = async (
  params: {
    // filters
    locations?: string[] | string;
    outlet_category?: string[] | string;
    device_type?: string[] | string;
    pmi_entity_code?: string[] | string;
    outlet_name?: string[] | string;

    // last login range (either flat or object form)
    lastLogin_from?: string;
    lastLogin_to?: string;
    lastLogin?: { from?: string; to?: string };

    // search & paging
    search?: string;
    page?: number;
    limit?: number | "all" | string;

    // selected columns: either field keys from the table or already UI labels
    columns?: string[] | string;

    // force CSV on the server
    export?: boolean;
  },
  token?: string,
  forceBlob?: boolean // pass true from your "Export CSV" button handler
) => {
  // inline helpers (kept inside the function per your request)
  const writeArrayOrString = (qs: URLSearchParams, key: string, value?: string[] | string) => {
    if (value == null) return;
    if (Array.isArray(value)) {
      if (value.length) qs.set(key, value.join(","));
    } else {
      const v = String(value).trim();
      if (v) qs.set(key, v);
    }
  };

  // maps your table field keys → UI labels expected by COLUMN_MAP in BE service
  const valueToLabel = (k: string): string => {
    const map: Record<string, string> = {
      user_id: "User ID",
      user_salesforce_id: "User Salesforce ID",
      pmi_entity_code: "PMI Entity Code",
      user_first_name: "User First Name",
      user_last_name: "User Last Name",
      outlet_name: "Outlet Name",
      city: "City",
      outlet_category: "Outlet Category",
      phone_number: "Phone Number",
      login_date: "Login Date",
      login_time: "Login Time",
      otp_trigger_success: "OTP Trigger Success",
      device_os: "Device OS",
      device_os_version: "Device OS Version",
      browser_name: "Browser Name",
      browser_version: "Browser Version",
      notifications_consent_status: "Notifications Consent Status",
      geolocation_consent_status: "Geolocation Consent Status",
    };
    return map[k] || k; // if already a UI label, pass through
  };

  const qs = new URLSearchParams();

  // filters
  writeArrayOrString(qs, "locations", params.locations);
  writeArrayOrString(qs, "outlet_category", params.outlet_category);
  writeArrayOrString(qs, "device_type", params.device_type);
  writeArrayOrString(qs, "pmi_entity_code", params.pmi_entity_code);
  writeArrayOrString(qs, "outlet_name", params.outlet_name);

  // last login range
  const lf = params.lastLogin_from ?? params.lastLogin?.from;
  const lt = params.lastLogin_to ?? params.lastLogin?.to;
  if (lf) qs.set("lastLogin_from", lf);
  if (lt) qs.set("lastLogin_to", lt);

  // paging & search
  if (params.search) qs.set("search", params.search);
  if (params.page != null) qs.set("page", String(params.page));
  if (params.limit != null) qs.set("limit", String(params.limit));

  // columns → send UI labels that match BE COLUMN_MAP
  if (params.columns) {
    const list = Array.isArray(params.columns)
      ? params.columns
      : String(params.columns).split(",").map((s) => s.trim()).filter(Boolean);
    const uiLabels = list.map(valueToLabel).filter(Boolean);
    if (uiLabels.length) qs.set("columns", uiLabels.join(","));
  }

  // export flag (CSV)
  const wantsCsv =
    !!forceBlob ||
    String(params.limit || "").toLowerCase() === "all" ||
    String(params.export || "").toLowerCase() === "true";
  if (typeof params.export !== "undefined") qs.set("export", String(wantsCsv));

  const url = qs.toString()
    ? `/reports/filters-login-reports-dynamic?${qs.toString()}`
    : `/reports/filters-login-reports-dynamic`;

  // debug (optional)
  console.log("[EXPORT R&A FE] final URL:", url);

  const config: any = wantsCsv ? { responseType: "blob" } : {};
  if (token) config.headers = { Authorization: `Bearer ${token}` };

  const response = await apiClient.get(url, config);
  return response.data; // Blob if CSV, JSON otherwise
};


export const exportIrAnalysis = async (
  reqBody: {
    city?: string | string[];
    locations?: string | string[];
    outlet_category?: string[];
    pmi_entity_code?: string[];
    outlet_name?: string[];
    page?: number;
    limit?: number | string; // allow string "all"
    lastLogin?: { from: string; to: string };
    export?: boolean;        // optional export flag
  },
  loginToken: string,
  exportCSV?: boolean
): Promise<any> => {
  try {
    const endpoint = "/reports/getting_ir_data";

    const response = await apiClient.post(endpoint, reqBody, {
      headers: {
        Authorization: `Bearer ${loginToken}`,
      },
      // withCredentials: true,
      responseType: exportCSV ? "blob" : "json",
    });

    if (exportCSV && response.data) {
      return response.data; // Blob
    }

    return response.data; // JSON
  } catch (error) {
    console.error("Error exporting retailers and accounts:", error);
    throw error;
  }
};


export const exportIrSummReport_csv = async (
  params: {
    // filters
    locations?: string[] | string;
    city?: string[] | string;                // alias for locations
    outlet_category?: string[] | string;
    pmi_entity_code?: string[] | string;
    outlet_name?: string[] | string;
    search?: string;                          // NEW: free-text search

    // paging & export
    page?: number;
    limit?: number | "all" | string;

    // selected columns (field keys or UI labels)
    columns?: string[] | string;

    // force CSV
    export?: boolean;
  },
  token?: string,
  forceBlob?: boolean // pass true from Export CSV button
) => {
  const qs = new URLSearchParams();

  // helpers
  const writeArrayOrString = (key: string, value?: string[] | string) => {
    if (value == null) return;
    if (Array.isArray(value)) {
      if (value.length) qs.set(key, value.join(","));
    } else {
      const v = String(value).trim();
      if (v) qs.set(key, v);
    }
  };
  const writeString = (key: string, value?: string) => {
    if (!value) return;
    const v = String(value).trim();
    if (v) qs.set(key, v);
  };

  // Map table field keys → UI labels expected by BE COLUMN_MAP (IR version)
  const valueToLabel = (k: string): string => {
    const map: Record<string, string> = {
      region: "Region",
      asm_name: "ASM Name",
      area_code: "Area Code",
      tse_name: "TSE Name",
      territory_code: "Territory Code",
      pmi_entity_code: "PMI Entity Code",
      outlet_name: "Outlet Name",
      city: "City",
      outlet_category: "Outlet Category",
      latest_image_capture_date: "Latest Image Capture Date",
      latest_ir_self_facings: "Latest IR Self Facings",
      latest_ir_competition_facings: "Latest IR Competition Facings",
      latest_ir_others_facings: "Latest IR Others Facings",
      latest_image_link: "Latest Image Link",
    };
    return map[k] || k; // if already a UI label, passthrough
  };

  // ---- filters ----
  // Support either locations or city; locations wins if both provided
  const locs = params.locations ?? params.city;
  writeArrayOrString("locations", locs);
  writeArrayOrString("outlet_category", params.outlet_category);
  writeArrayOrString("pmi_entity_code", params.pmi_entity_code);
  writeArrayOrString("outlet_name", params.outlet_name);

  // NEW: free-text search
  writeString("search", params.search);

  // ---- paging ----
  if (params.page != null) qs.set("page", String(params.page));
  if (params.limit != null) qs.set("limit", String(params.limit));

  // ---- columns → send UI labels matching BE COLUMN_MAP ----
  if (params.columns) {
    const list = Array.isArray(params.columns)
      ? params.columns
      : String(params.columns).split(",").map((s) => s.trim()).filter(Boolean);
    const uiLabels = list.map(valueToLabel).filter(Boolean);
    if (uiLabels.length) qs.set("columns", uiLabels.join(","));
  }

  // ---- export flag (CSV) ----
  const wantsCsv =
    !!forceBlob ||
    String(params.limit || "").toLowerCase() === "all" ||
    String(params.export || "").toLowerCase() === "true";
  if (typeof params.export !== "undefined") qs.set("export", String(wantsCsv));

  const url = qs.toString()
    ? `/reports/export-ir-summary-report?${qs.toString()}`
    : `/reports/export-ir-summary-report`;

  const config: any = wantsCsv ? { responseType: "blob" } : {};
  if (token) config.headers = { Authorization: `Bearer ${token}` };

  const response = await apiClient.get(url, config);
  return response.data; // Blob if CSV, JSON otherwise
};



//This is for Getting the data in the Master Outlet List Report for the Table



//This is the Api call for the Export purpose(CSV) in the Login and Otp Report

export const exportLoginReportDynamic = async (params: {
  billing_city?: string;
  deviceType?: string;
  outlet_category?: string;
  dte_contact_id?: string;
  dte_account_id?: string;
  last_login_start?: string;
  last_login_end?: string;
}) => {
  const queryParams = new URLSearchParams({
    billing_city: params.billing_city || "",
    deviceType: params.deviceType || "",
    outlet_category: params.outlet_category || "",
    dte_contact_id: params.dte_contact_id || "",
    dte_account_id: params.dte_account_id || "",
    last_login_start: params.last_login_start || "",
    last_login_end: params.last_login_end || "",
  });

  const response = await apiClient.get(
    `/reports/filters-login-reports-dynamic?${queryParams.toString()}`,
    {
      responseType: "blob", // important
    }
  );

  return response.data;
};


//This is the Backend code for IR Analysis Report just for fetching in the Frontend(Basic Accounts)
export const exportBasicAccounts = async (
  reqBody: {
    locations?: string[];
    outlet_type?: string[];
    search?: string;
    page?: number;
    limit?: number;
  },
  // token: string,               // now required like in rewardPoint
  exportCSV?: boolean
): Promise<any> => {
  try {
    const endpoint = "/reports/get_basic_accounts";

    const response = await apiClient.post(endpoint, reqBody, {
      // headers: {
      //   // Authorization: `Bearer ${token}`, // send token properly
      // },
      responseType: exportCSV ? "blob" : "json",
    });

    // Handle CSV download if needed
    if (exportCSV && response.data) {
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "basic_accounts.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      return; // nothing else to return after download
    }

    // JSON response
    return response.data;
  } catch (error) {
    console.error("Error exporting basic accounts:", error);
    throw error;
  }
};


//This code is used for the Export purpose(CSV) in the IR Analysis Report (Basic Accounts)
export const exportIrReport = async (params: {
  billing_city?: string;
  outlet_category?: string;
  account_status?: string;
  created_start?: string;
  created_end?: string;
}) => {
  const queryParams = new URLSearchParams({
    billing_city: params.billing_city || "",
    outlet_category: params.outlet_category || "",
    account_status: params.account_status || "",
    created_start: params.created_start || "",
    created_end: params.created_end || "",
  });

  const response = await apiClient.get(
    `/reports/export-basic-accounts?${queryParams.toString()}`,
    {
      responseType: "blob", // important to download Excel
    }
  );

  return response.data;
};


export const exportIrTransReport = async (
  reqBody: {
    city?: string | string[];
    locations?: string | string[];
    outlet_category?: string[];
    pmi_entity_code?: string[];
    outlet_name?: string[];
    page?: number;
    limit?: number | string; // allow "all" for full export
    export?: boolean;        // optional export flag
  },
  loginToken: string,
  exportCSV?: boolean
): Promise<any> => {
  try {
    const endpoint = "/reports/getting_ir_trans";

    const response = await apiClient.post(endpoint, reqBody, {
      headers: {
        Authorization: `Bearer ${loginToken}`,
      },
      responseType: exportCSV ? "blob" : "json",
    });

    if (exportCSV && response.data) {
      return response.data; // Blob for CSV/Excel
    }

    return response.data; // JSON for list view
  } catch (error) {
    console.error("Error exporting IR transactions:", error);
    throw error;
  }
};

// FE API: export IR Transactions (CSV or JSON depending on flags)
export const exportIrTransReport_csv = async (
  params: {
    // filters (strict)
    locations?: string[] | string;
    outlet_category?: string[] | string;
    pmi_entity_code?: string[] | string;
    outlet_name?: string[] | string;
    transaction_from?: string; // "YYYY-MM-DD"
    transaction_to?: string;   // "YYYY-MM-DD"

    // paging & export
    page?: number;
    limit?: number | "all" | string;

    // selected columns (field keys or UI labels)
    columns?: string[] | string;

    // force CSV
    export?: boolean;
  },
  token?: string,
  forceBlob?: boolean // pass true from "Export CSV" button
) => {
  // helper: write arrays/strings to query params
  const writeArrayOrString = (qs: URLSearchParams, key: string, value?: string[] | string) => {
    if (value == null) return;
    if (Array.isArray(value)) {
      if (value.length) qs.set(key, value.join(","));
    } else {
      const v = String(value).trim();
      if (v) qs.set(key, v);
    }
  };

  // Map table field keys → UI labels expected by BE COLUMN_MAP (IR Transactions)
  const valueToLabel = (k: string): string => {
    const map: Record<string, string> = {
      // base
      transaction_date: "Transaction Date",
      region: "Region",
      asm_name: "ASM Name",
      area_code: "Area Code",
      tse_name: "TSE Name",
      territory_code: "Territory Code",
      pmi_entity_code: "PMI Entity Code",
      outlet_name: "Outlet Name",
      city: "City",
      outlet_category: "Outlet Category",

      // coords
      outlet_latitude: "Outlet Latitude",
      outlet_longitude: "Outlet Longitude",
      image_capture_latitude: "Image Capture Latitude",
      image_capture_longitude: "Image Capture Longitude",
      distance_of_image_capture: "Distance Of Image Capture",

      // task/meta
      task_id: "Task ID",
      published_id: "Published ID",
      activity_id: "Activity ID",

      // image/quality/reason
      image_link: "Image Link",
      image_quality: "Image Quality",
      rejection_reason: "Rejection Reason",
      task_parameter_response: "Task Parameter Response",

      // facings
      self_facings: "Self Facings",
      competition_facings: "Competition Facings",
      others_facings: "Others Facings",
    };
    return map[k] || k; // passthrough if already a label
  };

  const qs = new URLSearchParams();

  // filters
  writeArrayOrString(qs, "locations", params.locations);
  writeArrayOrString(qs, "outlet_category", params.outlet_category);
  writeArrayOrString(qs, "pmi_entity_code", params.pmi_entity_code);
  writeArrayOrString(qs, "outlet_name", params.outlet_name);

  if (params.transaction_from) qs.set("transaction_from", params.transaction_from);
  if (params.transaction_to) qs.set("transaction_to", params.transaction_to);

  // paging
  if (params.page != null) qs.set("page", String(params.page));
  if (params.limit != null) qs.set("limit", String(params.limit));

  // columns → send UI labels that backend COLUMN_MAP knows
  if (params.columns) {
    const list = Array.isArray(params.columns)
      ? params.columns
      : String(params.columns).split(",").map((s) => s.trim()).filter(Boolean);
    const uiLabels = list.map(valueToLabel).filter(Boolean);
    if (uiLabels.length) qs.set("columns", uiLabels.join(","));
  }

  // export flag (CSV)
  const wantsCsv =
    !!forceBlob ||
    String(params.limit || "").toLowerCase() === "all" ||
    String(params.export || "").toLowerCase() === "true";
  if (typeof params.export !== "undefined") qs.set("export", String(wantsCsv));

  // Endpoint pairs with your controller exportIrTransReport_csv
  const url = qs.toString()
    ? `/reports/export-ir-transactions-report?${qs.toString()}`
    : `/reports/export-ir-transactions-report`;

  const config: any = wantsCsv ? { responseType: "blob" } : {};
  if (token) config.headers = { Authorization: `Bearer ${token}` };

  const response = await apiClient.get(url, config);
  return response.data; // Blob if CSV, JSON otherwise
};



export interface TaskSummaryRequest {
  // Core filters (can be string or string[])
  task_id?: string[] | string;
  task_type_en?: string[] | string;
  account_id?: string[] | string;
  approval_status?: ("pending" | "approved" | "in_progress" | "rejected")[] | string;
  is_published?: boolean | string; // allow "true"/"false" from UI

  // Aliases (friendly names) -> normalize to *_from/_to used by backend
  task_start_from?: string; // YYYY-MM-DD
  task_start_to?: string;   // YYYY-MM-DD
  task_end_from?: string;   // YYYY-MM-DD
  task_end_to?: string;     // YYYY-MM-DD

  // Alternate date aliases (if UI uses these)
  taskStartFrom?: string;
  taskStartTo?: string;
  taskEndFrom?: string;
  taskEndTo?: string;

  // Search & pagination
  search?: string;
  q?: string;
  search_key?: string;
  page?: number | string;
  limit?: number | "all" | string;

  // CSV export
  columns?: string[] | string; // comma-separated or array of exact backend headers

  // Optional wrapper object (will be mirrored with normalized keys)
  filters?: Record<string, any>;
}

/**
 * Mirrors `master_outlet_list_v1`:
 * - Normalizes aliases to backend's expected keys
 * - Passes through a `filters` object with mirrored keys
 * - Supports CSV export when `exportCSV` is true (and optional `columns`)
 */
export const task_summary_v1 = async (
  reqBody: TaskSummaryRequest,
  token: string,
  exportCSV?: boolean
): Promise<any> => {
  try {
    // NOTE: change this if your route differs; kept explicit to avoid the old typo.
    const endpoint = "/reports/export-task_reprort";

    // --- clone first ---
    const normalized: any = { ...reqBody };

    // ---------- Aliases → strict backend keys ----------
    // Dates (task window)
    normalized.task_start_from =
      reqBody.task_start_from ?? (reqBody as any).taskStartFrom ?? null;
    normalized.task_start_to =
      reqBody.task_start_to ?? (reqBody as any).taskStartTo ?? null;
    normalized.task_end_from =
      reqBody.task_end_from ?? (reqBody as any).taskEndFrom ?? null;
    normalized.task_end_to =
      reqBody.task_end_to ?? (reqBody as any).taskEndTo ?? null;

    // Multi-select IDs / enums (keep arrays intact; backend supports arrays/CSV)
    normalized.task_id =
      reqBody.task_id ?? (reqBody as any).taskId ?? normalized.task_id;
    normalized.task_type_en =
      reqBody.task_type_en ?? (reqBody as any).taskTypeEn ?? normalized.task_type_en;
    normalized.account_id =
      reqBody.account_id ?? (reqBody as any).accountId ?? normalized.account_id;
    normalized.approval_status =
      reqBody.approval_status ??
      (reqBody as any).approvalStatus ??
      normalized.approval_status;

    // Booleans
    if (normalized.is_published === undefined) {
      normalized.is_published = (reqBody as any).isPublished;
    }
    if (typeof normalized.is_published === "string") {
      const s = normalized.is_published.trim().toLowerCase();
      if (s === "true" || s === "false") normalized.is_published = s === "true";
    }

    // Search (fold q/search_key into search)
    normalized.search =
      (reqBody.search ?? (reqBody as any).q ?? (reqBody as any).search_key ?? "") || undefined;

    // Pagination (pass through if provided)
    if (reqBody.page != null) normalized.page = reqBody.page;
    if (reqBody.limit != null) normalized.limit = reqBody.limit;

    // Columns (array → CSV for convenience; string is passed as-is)
    if (Array.isArray((reqBody as any).columns)) {
      normalized.columns = (reqBody as any).columns.join(",");
    }

    // Export flag (backend commonly checks this)
    if (exportCSV) normalized.export = true;

    // If caller uses wrapper "filters", mirror key fields there too
    if (normalized.filters && typeof normalized.filters === "object") {
      normalized.filters = {
        ...normalized.filters,
        // dates
        task_start_from:
          normalized.task_start_from ?? normalized.filters.task_start_from ?? null,
        task_start_to:
          normalized.task_start_to ?? normalized.filters.task_start_to ?? null,
        task_end_from:
          normalized.task_end_from ?? normalized.filters.task_end_from ?? null,
        task_end_to:
          normalized.task_end_to ?? normalized.filters.task_end_to ?? null,
        // flags / search
        is_published:
          normalized.is_published ?? normalized.filters.is_published ?? undefined,
        search: normalized.search ?? normalized.filters.search ?? undefined,
        // IDs/enums (mirror without clobbering)
        task_id: normalized.task_id ?? normalized.filters.task_id,
        task_type_en: normalized.task_type_en ?? normalized.filters.task_type_en,
        account_id: normalized.account_id ?? normalized.filters.account_id,
        approval_status:
          normalized.approval_status ?? normalized.filters.approval_status,
      };
    }

    const response = await apiClient.post(endpoint, normalized, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: exportCSV ? "blob" : "json",
    });

    if (exportCSV && response.data) {
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `task_summary_${new Date().toISOString().slice(0, 10)}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return blob;
    }

    return response.data;
  } catch (error: any) {
    console.error("Error calling task_summary_v1:", error);
    throw error;
  }
};



/** ========== FILTER OPTIONS (Summary) ========== */
export type TaskSummFilterPayload =
  | {
      outlet_name?: string[] | null;       // accounts.name
      pmi_entity_code?: string[] | null;   // accounts.dte_account_id
      task_type_en?: string[] | null;      // tasks.task_type_en
      task_start_from?: string | null;     // yyyy-MM-dd
      task_start_to?: string | null;       // yyyy-MM-dd
      task_end_from?: string | null;       // yyyy-MM-dd
      task_end_to?: string | null;         // yyyy-MM-dd
      search_key?: string | null;          // outlet name / mobile / user name
    }
  | string[] // keep parity if your caller sometimes sends an array
  | null;

export async function getTaskSummFilterOptions(
  payload: TaskSummFilterPayload,
  token: string,
  signal?: AbortSignal
) {
  try {
    const normalize = (obj: any) => {
      const out: any = { page: 1, limit: 1 };

      const addArr = (k: string, v: any) => {
        if (Array.isArray(v) && v.length) out[k] = v;
      };
      const addOpt = (k: string, v: any) => {
        if (v !== undefined && v !== null && v !== "") out[k] = v;
      };

      addArr("outlet_name", obj.outlet_name);
      addArr("pmi_entity_code", obj.pmi_entity_code);
      addArr("task_type_en", obj.task_type_en);

      addOpt("task_start_from", obj.task_start_from);
      addOpt("task_start_to", obj.task_start_to);
      addOpt("task_end_from", obj.task_end_from);
      addOpt("task_end_to", obj.task_end_to);
      addOpt("search_key", obj.search_key);

      return out;
    };

    const reqBody =
      Array.isArray(payload) || payload === null
        ? { page: 1, limit: 1, outlet_name: payload ?? null }
        : normalize(payload || {});

    const response: AxiosResponse<any> = await apiClient.post(
      "/reports/export-task_reprort",
      reqBody,
      { headers: { Authorization: `Bearer ${token}` }, signal }
    );

    const body = response?.data ?? {};
    const host =
      body && typeof body === "object" && body.data && typeof body.data === "object"
        ? body.data
        : body;

    return {
      available_outlet_names: Array.isArray(host?.available_outlet_names) ? host.available_outlet_names : [],
      available_pmi_codes: Array.isArray(host?.available_pmi_codes) ? host.available_pmi_codes : [],
      available_task_types: Array.isArray(host?.available_task_types) ? host.available_task_types : [],
    };
  } catch (error) {
    console.error("Error fetching Task Summary filter options:", error);
    return {
      available_outlet_names: [],
      available_pmi_codes: [],
      available_task_types: [],
    };
  }
}

/** ========== REPORT (Summary) ========== */
export type TaskSummReportRequest = {
  // filters
  outlet_name?: string[];
  pmi_entity_code?: string[];
  task_type_en?: string[];
  // task window
  task_start_from?: string; // yyyy-MM-dd
  task_start_to?: string;   // yyyy-MM-dd
  task_end_from?: string;   // yyyy-MM-dd
  task_end_to?: string;     // yyyy-MM-dd
  // global search (outlet name / mobile / user name)
  search_key?: string;

  // paging
  page?: number;
  limit?: number | "all";

  // export controls (if you stream CSV)
  export?: boolean;
  columns?: string[]; // strict server keys
};

export const exportTaskSummReport = async (
  reqBody: TaskSummReportRequest,
  loginToken: string,
): Promise<any> => {
  try {
    const endpoint = "/reports/export-task_reprort";
    const response = await apiClient.post(endpoint, reqBody, {
      headers: {
        withCredentials: true,
        Authorization: `Bearer ${loginToken}`,
      },
      responseType: "json",
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching task summary report:", error);
    throw error;
  }
};

/** ========== CSV (Summary) — optional ========== */
export const exportTaskSummExportCSV = async (
  body: {
    filters?: TaskSummReportRequest;
    scope?: "filtered" | "all";
    columnsMode?: "all" | "selected";
    selectedColumns?: string[];
    stream?: boolean;
  },
  loginToken: string
): Promise<{ blob: Blob; filename: string }> => {
  const endpoint = "/reports/export-task_reprort_csv";

  const response = await apiClient.post<Blob>(endpoint, body, {
    headers: {
      withCredentials: true,
      Authorization: `Bearer ${loginToken}`,
    },
    responseType: "blob",
  });

  const headers = response.headers as Record<string, string | undefined>;
  const disp = headers["content-disposition"] || "";
  let filename = `task_summary_report_${new Date().toISOString().slice(0, 10)}.csv`;

  if (typeof disp === "string" && disp) {
    const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(disp);
    const found = decodeURIComponent((m?.[1] || m?.[2] || "").trim());
    if (found) filename = found;
  }

  const contentType = headers["content-type"] || "";
  if (
    contentType &&
    !contentType.includes("text/csv") &&
    !contentType.includes("application/octet-stream")
  ) {
    try {
      const text = await (response.data as Blob).text();
      throw new Error(text);
    } catch {
      /* ignore */
    }
  }

  return { blob: response.data as Blob, filename };
};


type TaskTransFilterPayload =
  | {
      locations?: string[] | null;
      outlet_name?: string[] | null;
      pmi_entity_code?: string[] | null;
      outlet_category?: string[] | null;
      task_id?: (string | number)[] | null;
      transaction_from?: string | null; // yyyy-MM-dd
      transaction_to?: string | null;   // yyyy-MM-dd
      search_key?: string | null;
    }
  | string[]              
  | null;                 

export async function getTaskTransFilterOptions(
  payload: TaskTransFilterPayload,
  token: string,
  signal?: AbortSignal
) {
  try {
    // —— Normalize payload to an object and only include non-empty arrays/defined values ——
    const normalize = (obj: any) => {
      const out: any = { page: 1, limit: 1 };

      const addArr = (k: string, v: any) => {
        if (Array.isArray(v) && v.length) out[k] = v;
      };
      const addOpt = (k: string, v: any) => {
        if (v !== undefined && v !== null && v !== "") out[k] = v;
      };

      addArr("locations", obj.locations);
      addArr("outlet_name", obj.outlet_name);
      addArr("pmi_entity_code", obj.pmi_entity_code);
      addArr("outlet_category", obj.outlet_category);
      addArr("task_id", obj.task_id);

      addOpt("transaction_from", obj.transaction_from);
      addOpt("transaction_to", obj.transaction_to);
      addOpt("search_key", obj.search_key);

      return out;
    };

    const reqBody =
      Array.isArray(payload) || payload === null
        ? { page: 1, limit: 1, locations: payload ?? null }
        : normalize(payload || {});

    // —— Use the same header style as getReportsFilterOptions_v2 ——
    const response: AxiosResponse<any> = await apiClient.post(
      "/reports/export-task-transaction-report",
      reqBody,
      { headers: { Authorization: `Bearer ${token}` }, signal }
    );

    // Some controllers return data at top-level, others under .data
    const body = response?.data ?? {};
    const host =
      body && typeof body === "object" && body.data && typeof body.data === "object"
        ? body.data
        : body;

    return {
      available_cities: Array.isArray(host?.available_cities) ? host.available_cities : [],
      available_outlet_categories: Array.isArray(host?.available_outlet_categories)
        ? host.available_outlet_categories
        : [],
      available_outlet_names: Array.isArray(host?.available_outlet_names) ? host.available_outlet_names : [],
      available_pmi_codes: Array.isArray(host?.available_pmi_codes) ? host.available_pmi_codes : [],
    };
  } catch (error) {
    console.error("Error fetching TaskTrans filter options:", error);
    // Keep shape stable on failures
    return {
      available_cities: [],
      available_outlet_categories: [],
      available_outlet_names: [],
      available_pmi_codes: [],
    };
  }
}

export type TaskTransReportRequest = {
  // filters
  locations?: string[];
  outlet_category?: string[];
  pmi_entity_code?: string[];
  outlet_name?: string[];
  task_id?: (string | number)[];

  // date window (mapped to UTM.createdAt on BE)
  transaction_from?: string; // ISO string
  transaction_to?: string;   // ISO string

  // paging
  page?: number;
  limit?: number | "all";

  // export controls
  export?: boolean;
  columns?: string[]; // strict server field names (e.g., "Task ID", "Task Name", ...)
};

export const exportTaskTransReport = async (
  reqBody: TaskTransReportRequest,
  loginToken: string,
): Promise<any> => {
  try {
    const endpoint = "/reports/export-task-transaction-report"; // align with BE route name
    const response = await apiClient.post(endpoint, reqBody, {
      headers: {
        withCredentials: true,
        Authorization: `Bearer ${loginToken}`,
      },
      responseType: "json",
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching task transaction report:", error);
    throw error;
  }
};

export type TaskTransReportFilters = {
  page?: number | "all";
  limit?: number | "all";
  search_key?: string | null;
  transaction_from?: string | null;
  transaction_to?: string | null;
  locations?: string[];
  outlet_category?: string[];
  pmi_entity_code?: string[];
  outlet_name?: string[];
  task_id?: (string | number)[];
};

export const exportTaskTransExportCSV = async (
  body: {
    filters?: TaskTransReportFilters;         // <-- use the renamed type (or your single Request type)
    scope?: "filtered" | "all";
    columnsMode?: "all" | "selected";
    selectedColumns?: string[];
    stream?: boolean;                         // default true on BE
  },
  loginToken: string
): Promise<{ blob: Blob; filename: string }> => {
  const endpoint = "/reports/export-task-transaction-handler";

  const response = await apiClient.post<Blob>(endpoint, body, {
    headers: {
      withCredentials: true,
      Authorization: `Bearer ${loginToken}`,
    },
    responseType: "blob",
  });

  // ----- filename from Content-Disposition -----
  const headers = response.headers as Record<string, string | undefined>;
  const disp = headers["content-disposition"] || "";
  let filename = `task_transaction_report_${new Date().toISOString().slice(0, 10)}.csv`;

  if (typeof disp === "string" && disp) {
    // try RFC5987 then plain filename
    const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(disp);
    const found = decodeURIComponent((m?.[1] || m?.[2] || "").trim());
    if (found) filename = found;
  }

  // ----- content-type sanity check (if BE returned JSON error as blob) -----
  const contentType = headers["content-type"] || "";
  if (
    contentType &&
    !contentType.includes("text/csv") &&
    !contentType.includes("application/octet-stream")
  ) {
    try {
      const text = await (response.data as Blob).text();
      // Try to throw the server error content if it is JSON/text
      throw new Error(text);
    } catch {
      // ignore — proceed to return blob
    }
  }

  return { blob: response.data as Blob, filename };
};


//This is the Backend code for Master Outlet List Report just for fetching in the Frontend table
export const master_outlet_list_v1 = async (
  reqBody: {
    locations?: string[] | string;
    territory_codes?: string[] | string;
    user_status?: string[] | string;

    // possible incoming date variants
    lastLogin_from?: string;
    lastLogin_to?: string;
    lastloginStart?: string;
    lastloginEnd?: string;

    outlet_last_modified_date_from?: string;
    outlet_last_modified_date_to?: string;
    outletLastUpdatedStart?: string;
    outletLastUpdatedEnd?: string;

    outlet_category?: string[] | string;
    page?: number;
    limit?: number | "all" | string;
    search?: string;

    filters?: Record<string, any>;
  },
  token: string,
  exportCSV?: boolean
): Promise<any> => {
  try {
    const endpoint = "/reports/master_outlet_list_v1";

    // --- normalize dates ---
    const normalized: any = { ...reqBody };

    // 1) USER last updated (primary for Summary)
    const userFrom = reqBody.lastloginStart ?? reqBody.lastLogin_from ?? null;
    const userTo   = reqBody.lastloginEnd   ?? reqBody.lastLogin_to   ?? null;

    normalized.lastloginStart = userFrom;
    normalized.lastloginEnd   = userTo;

    // 2) OUTLET last updated (optional flow)
    const outletFrom =
      reqBody.outletLastUpdatedStart ?? reqBody.outlet_last_modified_date_from ?? null;
    const outletTo =
      reqBody.outletLastUpdatedEnd ?? reqBody.outlet_last_modified_date_to ?? null;

    normalized.outletLastUpdatedStart = outletFrom;
    normalized.outletLastUpdatedEnd   = outletTo;

    // If we are filtering by USER dates, drop outlet ones to avoid accidental empty results
    if (userFrom || userTo) {
      delete normalized.outlet_last_modified_date_from;
      delete normalized.outlet_last_modified_date_to;
      delete normalized.outletLastUpdatedStart;
      delete normalized.outletLastUpdatedEnd;
    }

    // Mirror into wrapper filters (backend merges wrapper over top-level)
    if (normalized.filters && typeof normalized.filters === "object") {
      normalized.filters = {
        ...normalized.filters,
        lastloginStart:
          normalized.lastloginStart ?? normalized.filters.lastloginStart ?? null,
        lastloginEnd:
          normalized.lastloginEnd ?? normalized.filters.lastloginEnd ?? null,
        outletLastUpdatedStart:
          userFrom || userTo
            ? null
            : (normalized.outletLastUpdatedStart ??
               normalized.filters.outletLastUpdatedStart ??
               null),
        outletLastUpdatedEnd:
          userFrom || userTo
            ? null
            : (normalized.outletLastUpdatedEnd ??
               normalized.filters.outletLastUpdatedEnd ??
               null),
      };
    }

    const response = await apiClient.post(endpoint, normalized, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: exportCSV ? "blob" : "json",
    });

    if (exportCSV && response.data) {
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "retailers_accounts.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return blob;
    }

    return response.data;
  } catch (error: any) {
    console.error("Error exporting retailers and accounts:", error);
    throw error;
  }
};


export const master_outlet_list_extended_v2 = async (
  reqBody: {
    locations?: string[] | string;
    outlet_city?: string[] | string;
    outlet_name?: string[] | string;
    outletNames?: string[] | string;
    pmi_entity_code?: string[] | string;
    region?: string[] | string;
    asm_name?: string[] | string;
    area_code?: string[] | string;
    tse_name?: string[] | string;
    territory_code?: string[] | string;
    sfa_id?: string[] | string;
    outlet_salesforce_id?: string[] | string;
    user_status?: string[] | string;
    status?: string[] | string;
    contract_since_from?: string;
    contract_since_to?: string;
    backendFilters?: { contract_from?: string; contract_to?: string; [k: string]: any };
    search?: string | string[];
    page?: number;
    limit?: number | "all" | string;
    sort_by_user_id?: "asc" | "desc" | string;
    user_id_sort?: "asc" | "desc" | string;
    sort?: string; // "user_id_asc" | "user_id_desc"
  },
  token: string,
  exportCSV?: boolean
): Promise<any> => {
  try {
    const endpoint = "/reports/master_outlet_list_v2";

    // --- normalize & map to service keys (kept from your version) ---
    const toArray = (v: any): any[] => {
      if (v == null) return [];
      if (Array.isArray(v)) return v;
      const s = String(v);
      return s.trim() ? s.split(",").map((x) => x.trim()).filter(Boolean) : [];
    };
    const upperArray = (v: any): string[] => toArray(v).map((x) => String(x).toUpperCase());

    const payload: any = {};

    // City
    const outletCityArr = toArray(reqBody.outlet_city).length
      ? toArray(reqBody.outlet_city)
      : toArray(reqBody.locations);
    if (outletCityArr.length) payload.outlet_city = outletCityArr;

    // Outlet name (strict)
    const outletNameArr = toArray(reqBody.outlet_name).length
      ? toArray(reqBody.outlet_name)
      : toArray((reqBody as any).outletNames);
    if (outletNameArr.length) payload.outlet_name = outletNameArr;

    // PMI (strict)
    if (toArray(reqBody.pmi_entity_code).length)
      payload.pmi_entity_code = toArray(reqBody.pmi_entity_code);

    // Hierarchy/codes
    if (toArray(reqBody.region).length)             payload.region = toArray(reqBody.region);
    if (toArray(reqBody.asm_name).length)           payload.asm_name = toArray(reqBody.asm_name);
    if (toArray(reqBody.area_code).length)          payload.area_code = toArray(reqBody.area_code);
    if (toArray(reqBody.tse_name).length)           payload.tse_name = toArray(reqBody.tse_name);
    if (toArray(reqBody.territory_code).length)     payload.territory_code = toArray(reqBody.territory_code);
    if (toArray(reqBody.sfa_id).length)             payload.sfa_id = toArray(reqBody.sfa_id);
    if (toArray(reqBody.outlet_salesforce_id).length)
      payload.outlet_salesforce_id = toArray(reqBody.outlet_salesforce_id);

    // Status -> user_status (UPPERCASE)
    const userStatus = upperArray(reqBody.user_status);
    const statusAlias = upperArray((reqBody as any).status);
    if (userStatus.length)       payload.user_status = userStatus;
    else if (statusAlias.length) payload.user_status = statusAlias;

    // Contracted since
    if (reqBody.contract_since_from) payload.contract_since_from = reqBody.contract_since_from;
    if (reqBody.contract_since_to)   payload.contract_since_to = reqBody.contract_since_to;

    // backendFilters passthrough
    if (reqBody.backendFilters && typeof reqBody.backendFilters === "object") {
      payload.filters = { ...reqBody.backendFilters };
      if (reqBody.backendFilters.contract_from) payload.contract_from = reqBody.backendFilters.contract_from;
      if (reqBody.backendFilters.contract_to)   payload.contract_to = reqBody.backendFilters.contract_to;
    }

    // Search
    if (Array.isArray(reqBody.search)) payload.search = reqBody.search.join(" ");
    else if (typeof reqBody.search === "string" && reqBody.search.trim())
      payload.search = reqBody.search.trim();

    // Pagination / limit
    if (typeof reqBody.page !== "undefined")  payload.page  = reqBody.page;
    if (typeof reqBody.limit !== "undefined") payload.limit = reqBody.limit;

    // Sorting
    if (reqBody.sort_by_user_id) payload.sort_by_user_id = String(reqBody.sort_by_user_id);
    if (reqBody.user_id_sort)    payload.user_id_sort    = String(reqBody.user_id_sort);
    if (reqBody.sort)            payload.sort            = String(reqBody.sort);

    // --- call API; match exportRetailersAndAccounts semantics ---
    const response = await apiClient.post(endpoint, payload, {
      headers: { withCredentials: true, Authorization: `Bearer ${token}` },
      responseType: exportCSV ? "blob" : "json",
    });

    if (exportCSV && response.data) {
      // When/if the controller returns CSV for export routes, this returns the Blob.
      return response.data;
    }

    // JSON shape (v1-like service/controller)
    return response.data;
  } catch (error) {
    console.error("Error fetching master outlet list v2:", error);
    throw error;
  }
};



// This is the Backend code for Master Outlet List Report just for fetching in the Frontend exporting as CSV
export const exportMasterOutletList = async (
  params: {
    locations?: string[] | string;
    outlet_city?: string[] | string;
    outlet_name?: string[] | string;
    outletNames?: string[] | string;

    // ✅ NEW: status accepted (alias for user_status)
    status?: string[] | string;
    user_status?: string[] | string;

    outlet_category?: string[] | string;
    pmi_entity_code?: string[] | string;

    // header/picker (user Last Updated On)
    lastloginStart?: string; // e.g. "2025-09-01"
    lastloginEnd?: string;   // e.g. "2025-10-01"
    lastLogin_from?: string; // normalized below
    lastLogin_to?: string;   // normalized below

    // keep but we won't set them from Summary flow
    outlet_last_modified_date_from?: string;
    outlet_last_modified_date_to?: string;
    contract_since_from?: string;
    contract_since_to?: string;

    // misc
    region?: string[] | string;
    asm_name?: string[] | string;
    area_code?: string[] | string;
    tse_name?: string[] | string;
    territory_code?: string[] | string;
    territory_codes?: string[] | string;
    sfa_id?: string[] | string;

    // existing (keep)
    outlet_salesforce_id?: string[] | string;

    // ✅ NEW: user facet
    user_salesforce_id?: string[] | string;

    columns?: string[] | string;
    page?: number;
    limit?: number | "all" | string;
    search?: string;
    export?: boolean;
  },
  token?: string
) => {
  const queryParams = new URLSearchParams();

  const writeArrayOrString = (key: string, value?: string[] | string) => {
    if (value == null) return;
    if (Array.isArray(value)) {
      if (value.length) queryParams.set(key, value.join(","));
    } else {
      const v = String(value).trim();
      if (v) queryParams.set(key, v);
    }
  };

  // ---------- NORMALIZE KEYS (no UI change) ----------
  // Prefer explicit lastLogin_*; otherwise accept lastloginStart/End from caller.
  const normLastLoginFrom = params.lastLogin_from ?? params.lastloginStart ?? undefined;
  const normLastLoginTo   = params.lastLogin_to   ?? params.lastloginEnd   ?? undefined;

  // Allow FE to pass either outlet_name or outletNames
  const normOutletName = params.outlet_name ?? params.outletNames ?? undefined;

  // Locations can map to outlet_city for the CSV service
  const normOutletCity = params.outlet_city ?? params.locations ?? undefined;

  // ✅ status alias handling (many CSV backends read user_status, some read status)
  const normUserStatus = params.status ?? params.user_status ?? undefined;

  // ---------- WRITE FILTERS ----------
  // keep original pass-throughs
  // ---------- WRITE FILTERS ----------

// columns & paging
writeArrayOrString("columns", params.columns);
if (params.search) queryParams.set("search", params.search);
if (params.page) queryParams.set("page", String(params.page));
if (params.limit !== undefined && params.limit !== null) queryParams.set("limit", String(params.limit));
if (typeof params.export !== "undefined") queryParams.set("export", String(params.export));

// Locations — send BOTH spellings the BE might read
writeArrayOrString("outlet_city", normOutletCity);
writeArrayOrString("locations",   normOutletCity);

// Outlet names — send BOTH
writeArrayOrString("outlet_name", normOutletName);
writeArrayOrString("outletNames", normOutletName);

// PMI — send BOTH
writeArrayOrString("pmi_entity_code", params.pmi_entity_code);
writeArrayOrString("pmiEntityCodes",  params.pmi_entity_code);

// Status — send BOTH (you already normalize it)
if (normUserStatus) {
  writeArrayOrString("user_status", normUserStatus);
  writeArrayOrString("status",      normUserStatus);
}

// User SFA facet
writeArrayOrString("user_salesforce_id", params.user_salesforce_id);

// Other unchanged (if your CSV service uses any of these)
writeArrayOrString("outlet_category", params.outlet_category);
writeArrayOrString("region", params.region);
writeArrayOrString("asm_name", params.asm_name);
writeArrayOrString("area_code", params.area_code);
writeArrayOrString("tse_name", params.tse_name);
writeArrayOrString("territory_code", params.territory_code);
writeArrayOrString("territory_codes", params.territory_codes);
writeArrayOrString("sfa_id", params.sfa_id);
writeArrayOrString("outlet_salesforce_id", params.outlet_salesforce_id);

// Dates (user last updated range)
if (normLastLoginFrom) queryParams.set("lastLogin_from", normLastLoginFrom);
if (normLastLoginTo)   queryParams.set("lastLogin_to",   normLastLoginTo);

// Legacy/other date keys (left as-is)
if (params.outlet_last_modified_date_from) queryParams.set("outlet_last_modified_date_from", params.outlet_last_modified_date_from);
if (params.outlet_last_modified_date_to)   queryParams.set("outlet_last_modified_date_to",   params.outlet_last_modified_date_to);
if (params.contract_since_from)            queryParams.set("contract_since_from",             params.contract_since_from);
if (params.contract_since_to)              queryParams.set("contract_since_to",               params.contract_since_to);

  if (typeof params.export !== "undefined") queryParams.set("export", String(params.export));

  const qs = queryParams.toString();
  const url = qs ? `/reports/export-master-report?${qs}` : `/reports/export-master-report`;

  console.log("[EXPORT FE] final URL:", url);

  const config: any = { responseType: "blob" };
  if (token) config.headers = { Authorization: `Bearer ${token}` };

  const response = await apiClient.get(url, config);
  return response.data; // Blob
};



  
// exportMas// keep your import path

export const exportRetailersAndAccounts_csv_v1 = async (
  params: {
    // STRICT Master filters
    region?:string[] | string;
    // add to params type
    regions?: string[] | string;
    city?: string[] | string;
    asm_name?: string[] | string;
    area_code?: string[] | string;
    tse_name?: string[] | string;
    territory_code?: string[] | string;
    sfa_id?: string[] | string;
    outlet_salesforce_id?: string[] | string;
    pmi_entity_code?: string[] | string;
    outlet_name?: string[] | string;
    status?: string[] | string;

    // date ranges
    contractedSince_from?: string;
    contractedSince_to?: string;
    lastUpdated_on_from?: string;
    lastUpdated_on_to?: string;

    // search/sort/paging
    search?: string;
    q?: string;
    keyword?: string;
    sort_dir?: SortDir;
    page?: number;
    limit?: number | "all" | string;

    // selected columns (can be field keys or already UI headers)
    columns?: string[] | string;

    // force CSV
    export?: boolean;
  },
  token?: string,
  forceBlob?: boolean
) => {
  // helpers
  const joinIfArray = (v?: string[] | string) =>
    Array.isArray(v) ? v.join(",") : v;

  // Master key -> Header (must match BE COLUMN_MAP in exportRetailersAndAccounts_M1_csv)
  const keyToHeader = (k: string): string => {
    const map: Record<string, string> = {
      region:               "Region",
      asm_name:             "ASM Name",
      area_code:            "Area Code",
      tse_name:             "TSE Name",
      territory_code:       "Territory Code",
      sfa_id:               "SFA ID",
      outlet_salesforce_id: "Outlet Salesforce ID",
      pmi_entity_code:      "PMI Entity Code",
      user_id:              "User ID",
      user_first_name:      "User First Name",
      user_last_name:       "User Last Name",
      outlet_name:          "Outlet Name",
      city:                 "Outlet City",
      contracted_since:     "Contracted Since",
      current_rental_value: "Current Rental Value",
      status:               "Status",
      last_updated_on:      "Last Updated On",
    };
    return map[k] || k; // pass through if already a header
  };

  // columns: accept keys or headers; always send headers to BE
  const normalizeColumns = (cols?: string[] | string) => {
    if (!cols) return undefined;
    const list = Array.isArray(cols)
      ? cols
      : String(cols).split(",").map((s) => s.trim()).filter(Boolean);
    const headers = list.map(keyToHeader).filter(Boolean);
    return headers.length ? headers.join(",") : undefined;
  };

  // decide CSV/JSON
  const wantsCsv =
    !!forceBlob ||
    String(params.limit || "").toLowerCase() === "all" ||
    String(params.export || "").toLowerCase() === "true";

  // Build Master request body (same shape/keys as exportRetailersAndAccounts_v1)
  const reqBody: any = {
    // filters
    // include in reqBody build (right after region)
    ...(params.region  ? { region:  joinIfArray(params.region) }   : {}),
    ...(params.regions ? { regions: joinIfArray(params.regions) } : {}), // <-- add this
    ...(params.city ? { city: joinIfArray(params.city) } : {}),
    ...(params.asm_name ? { asm_name: joinIfArray(params.asm_name) } : {}),
    ...(params.area_code ? { area_code: joinIfArray(params.area_code) } : {}),
    ...(params.tse_name ? { tse_name: joinIfArray(params.tse_name) } : {}),
    ...(params.territory_code ? { territory_code: joinIfArray(params.territory_code) } : {}),
    ...(params.sfa_id ? { sfa_id: joinIfArray(params.sfa_id) } : {}),
    ...(params.outlet_salesforce_id ? { outlet_salesforce_id: joinIfArray(params.outlet_salesforce_id) } : {}),
    ...(params.pmi_entity_code ? { pmi_entity_code: joinIfArray(params.pmi_entity_code) } : {}),
    ...(params.outlet_name ? { outlet_name: joinIfArray(params.outlet_name) } : {}),
    ...(params.status ? { status: joinIfArray(params.status) } : {}),

    // dates
    ...(params.contractedSince_from ? { contractedSince_from: params.contractedSince_from } : {}),
    ...(params.contractedSince_to ? { contractedSince_to: params.contractedSince_to } : {}),
    ...(params.lastUpdated_on_from ? { lastUpdated_on_from: params.lastUpdated_on_from } : {}),
    ...(params.lastUpdated_on_to ? { lastUpdated_on_to: params.lastUpdated_on_to } : {}),

    // search/sort/paging
    ...(params.search ? { search: params.search } : {}),
    ...(params.q ? { q: params.q } : {}),
    ...(params.keyword ? { keyword: params.keyword } : {}),
    ...(params.sort_dir ? { sort_dir: params.sort_dir } : {}),
    ...(params.page != null ? { page: params.page } : {}),
    ...(params.limit != null ? { limit: params.limit } : {}),

    // columns as headers for BE CSV projection
    ...(normalizeColumns(params.columns) ? { columns: normalizeColumns(params.columns) } : {}),

    // export hint for BE
    ...(typeof params.export !== "undefined" ? { export: wantsCsv } : wantsCsv ? { export: true } : {}),
  };

  // same endpoint/layout as exportRetailersAndAccounts_v1
  const endpoint = "/reports/export-master-report-dynamics";

  const config: any = {
    responseType: wantsCsv ? "blob" : "json",
    headers: {
      withCredentials: true,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };

  const response = await apiClient.post(endpoint, reqBody, config);
  return response.data; // Blob if CSV, JSON otherwise
};







//This is the Api call for the Filter purpose in the Master Outlet List Report
export const filtered_master_outlet_list = async (
  params: {
    locations?: string[];
    search?: string;
    page?: number;
    limit?: number;
    lastLogin?: string;
  },
  token: string
): Promise<any> => {
  const queryParams = new URLSearchParams();
  if (params.locations && params.locations.length > 0) {
    queryParams.append("locations", params.locations.join(","));
  }
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page.toString());
  if (params.limit) queryParams.append("limit", params.limit.toString());
  if (params.lastLogin) queryParams.append("lastLogin", params.lastLogin);

  const response = await apiClient.get(
    `/reports/get-filtered-lop?${queryParams.toString()}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};